export const CommunityGetSchema = {
    id: 'id',
    topologyError: 'topologyError',
    description: 'description',
    parentCommunity: 'parentComm',
    availableParentCommunities: 'parentCommList',
    topologyType: 'topologyType',
    topologyTypeValues: {
        fullMesh: 'FULL_MESH',
        star: 'STAR',
        none: 'NONE'
    },
    centerGatewayId: 'centerGatewayId',
    satelliteRouting: 'satelliteRouting',
    satelliteRoutingValues: {
        NO_SATELLITE_COMMUNICATION: 'NO_SATELLITE_COMMUNICATION',
        THROUGH_CENTER: 'THROUGH_CENTER',
        INTERNET_THROUGH_CENTER: 'INTERNET_THROUGH_CENTER'
    },
    isBypassNat: 'isBypassNat',
    isPermanentTunnel: 'isPermanentTunnel',
    encryptionMethod: 'encryptionMethod',
    encryptionMethodValues: {
        ikev1: 'IKEV1',
        ikev2: 'IKEV2',
        preferIkev2SupportIkev1: 'Prefer_IKEV2_SUPPORT_IKEV1'
    },
    ikePhase1Encryption: 'ikePhase1Encryption',
    ikePhase1EncryptionValues: {
        tripleDes: 'TripleDES',
        aes128: 'AES128',
        aes256: 'AES256',
        des: 'DES',
        cast: 'CAST'
    },
    ikePhase1Integrity: 'ikePhase1Integrity',
    ikePhase1IntegrityValues: {
        md5: 'MD5',
        sha1: 'SHA1',
        sha256: 'SHA256',
        aesXcbc: 'AES_XCBC'
    },
    ikePhase1DiffieHellmanGroup: 'ikePhase1DiffieHellmanGroup',
    ikePhase1DiffieHellmanGroupValues: {
        group1: 'GROUP1',
        group2: 'GROUP2',
        group5: 'GROUP5',
        group14: 'GROUP14'
    },
    ikePhase1SALifetime: 'ikePhase1SALifetime',
    ikePhase2Encryption: 'ikePhase2Encryption',
    ikePhase2EncryptionValues: {
        tripleDes: 'TripleDES',
        aes128: 'AES128',
        aes256: 'AES256',
        des: 'DES',
        cast: 'CAST',
        des_40cp: 'DES40CP',
        cast_40: 'CAST40'
    },
    ikePhase2Integrity: 'ikePhase2Integrity',
    ikePhase2IntegrityValues: {
        md5: 'MD5',
        sha1: 'SHA1',
        sha256: 'SHA256',
        aesXcbc: 'AES_XCBC'
    },
    ikePhase2SecrecyEnabled: 'ikePhase2SecrecyEnabled',
    ikePhase2DiffieHellmanGroup: 'ikePhase2DiffieHellmanGroup',
    ikePhase2DiffieHellmanGroupValues: {
        group1: 'GROUP1',
        group2: 'GROUP2',
        group5: 'GROUP5',
        group14: 'GROUP14'
    },
    ikePhase2SALifetime: 'ikePhase2SALifetime',
    ikePhase2IPCompression: 'ikePhase2IPCompression',
    tunnelType: 'tunnelType',
    tunnelTypeValues: {
        tunnelPerGateway: 'TUNNEL_PER_GATEWAY',
        tunnelPerSubnet: 'TUNNEL_PER_SUBNET'
    },
    customFieldOne: 'customField1',
    customFieldTwo: 'customField2',
    customFieldSchema: {
        name: 'name',
        value: 'value'
    },
    createTime: 'createTime',
    lastTime: 'lastTime'
}

export const CommunityGetListSchema = {
    name: 'name',
    description: 'description',
    vpnType: 'vpnType',
    memberOf: 'memberOf',
    status: 'status',
    topologyError: 'topologyError'
}

export const CommunityVpnTypes = {
    fullMesh: 'FULL_MESH',
    star: 'STAR'
}

export const CommunityStatuses = {
    ok: 'TOPOLOGY_OK',
    outdated: 'TOPOLOGY_NOT_UP_TO_DATE'
}

export const CommunityFilterSchema = {
    name: 'name',
    memberOf: 'memberOf',
    vpnType: 'vpnType',
    topologyStatus: 'topologyStatus',
    creationDate: 'creationDate',
    modificationDate: 'modificationDate'
}

export const CommunityCreateSchema = {
    name: 'name',
    description: 'description'
}